import { GlobalSearchMinifiedInput } from 'global-search-externals';
import { useAppSelector } from '../../../hooks/redux';
import { useTranslation, useUser } from '../../../hooks/useNavConfig';
import useUsageTracker from '../../../hooks/useUsageTracker';
import { selectGates } from '../../../reducers/Portal';
import { isMac } from '../../../utils/isMac';
import memoWithDisplayName from '../../../utils/memoWithDisplayName';
import { SearchInputWrapper } from './Wrappers';
import { jsx as _jsx } from "react/jsx-runtime";
export const GlobalSearch = memoWithDisplayName('GlobalSearch', ({
  shouldDisplay
}) => {
  const {
    t
  } = useTranslation();
  const {
    trackSearchEvent
  } = useUsageTracker();
  const gates = useAppSelector(selectGates);
  const hasBreezeWidget = gates.includes('globalSearch:breezeWidget');
  const hasUIRefresh = gates.includes('globalSearch:uiRefresh');
  const {
    displayLanguage
  } = useUser();
  if (!shouldDisplay) {
    return null;
  }
  return /*#__PURE__*/_jsx(SearchInputWrapper, {
    children: /*#__PURE__*/_jsx(GlobalSearchMinifiedInput, {
      isMac: isMac(),
      trackSearchEvent: trackSearchEvent,
      translatedPlaceholderText: t('nav.search.searchInputPlaceholder'),
      translatedClearSearchLabel: t('nav.search.clearSearchLabel'),
      translatedSearchIconTitle: t('nav.icons.search'),
      language: displayLanguage,
      isResponsiveSearch: true,
      hasBreezeWidget: hasBreezeWidget,
      hasUIRefresh: hasUIRefresh
    })
  });
});